import CommonInputContainer from "./CommonInputContainer";

function CommonTextAreaInput({
  value,
  placeholder,
  onChange,
  label,
  error,
  onFocus,
  onBlur,
  className,
}) {
  return (
    <CommonInputContainer
      label={label}
      error={error && !value}
      className={className}
    >
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        onFocus={onFocus}
        onBlur={onBlur}
        className={`w-full h-32 items-center px-4 py-2 border resize-none ${
          error && !value ? "border-red-600" : "border-[#DBDBDB]"
        } rounded-lg placeholder:text-[#A4B1C1] focus:outline-none`}
      />
    </CommonInputContainer>
  );
}

export default CommonTextAreaInput;
